import React, { Component } from 'react'
import DataForm from './../../../components/DataForm/DataForm';
import FormInput from './../../../components/DataForm/FormInput';
import axios from '../../../axios';
import { Redirect } from 'react-router-dom';
import { Services } from '../../Service/Services';
import BoxContainer from '../../../components/BoxContainer/BoxContainer';

class OfflineCheckInRoomForm extends Component {
  // Set default state
  state = {
    data:{
      name: '',
      active: true,
    },
    datasource: {

    },
    redirect: false,
    loading: false,
  }

  retrieveData = id => {
    
  }

  componentDidMount = () => {
    const id = this.props.match.params.id;

    if(id !== undefined){
      this.retrieveData(id);
    }else{
      const loading = false;
      this.setState({loading});
    }
  }

  getValue = target => {
    let data = this.state.data;
    this.setState({
      data: {
        ...data,
        ...target
      }
    });
  }

  onSubmit = e => {
    // const params = this.state.data;
    // const url = this.props.url;
    // const redirect = true;
    // let loading = true;

    // this.setState({ loading });

    // Services.submitRequest({ params, url }).then( res => { this.setState({redirect, loading}) }).catch( errors => {this.setState({ errors,loading })});
  }

  getRedirect = () => {
    const redirect = this.state.redirect;
    
    if (redirect) {
      const url = this.props.url;

      return <Redirect to={url} />;
    }

    return;
  }

  getFields = () => {
    const id = this.state.id;

    var fields = [
      { label: 'วันที่', name: 'name', type: 'label', value: '01/09/2019' },
      { label: 'ห้อง', name: 'name', type: 'label', value: 'Room 1' },
      { label: 'หัวข้อ', name: 'name', type: 'label', value: 'Session 1' },
      { label: 'จำนวน', name: 'name', type: 'label', value: '10 / 100' },
      { label: 'Barcode or Code', name: 'name', type: 'textbox', value: '' },
    ];

    return fields;
  }

  render() {
    const fields = this.getFields();
    const redirect = this.getRedirect();
    const url = this.props.url;

    return (
      <BoxContainer loading={this.state.loading} errors={this.state.errors}>
        {redirect}
        <DataForm
          url={url}
          fields={fields}
          onSubmit={this.onSubmit}
          allow_save={false}
          getValue={this.getValue}
        >
          <div>
            <div className="alert alert-info">ข้อมูลผู้ใช้</div>
            <div className='p-3 bg-light'>
              <strong>รหัส:</strong>  A00001<br/>
              <strong>ชื่อ:</strong>  นาย A<br/>
              <strong>ลงทะเบียนเวลา: </strong> 01/09/2019 10:00:32
            </div>
          </div>
        </DataForm>
      </BoxContainer>
    )
  }
}

OfflineCheckInRoomForm.setDefaultProps = {
  url: '',
}

export default OfflineCheckInRoomForm
